import { gql } from '@apollo/client';

export const getRegiones = gql`
query getRegiones{
    regiones (tipo:$tipoBuscador)
    @rest(type: "Region[]", path: "/{args.tipo}/regionesvigentes"){
        codigo
        descripcion
    }
}`